<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <div class="alert alert-danger" v-if="Object.keys(dErrors).length">
          <span>{{ dErrors[Object.keys(dErrors)[0]][0] }}</span>
        </div>

        <div class="card">
          <div class="card-header">{{ i18n["login"] }}</div>
          <div class="card-body">
            <form method="POST" :action="loginUrl" @submit="handleSubmit">
              <input type="hidden" name="_token" :value="csrf" />
              <input-group
                :stored-id = "companyCode"
                name="company_code"
                :name-string="i18n['company_code']"
                type="text"
                :old="dOld"
                required
                autofocus
                @updateInputData="updateEnteredCompanyId"
              ></input-group>

              <input-group
                name="user_id"
                :name-string="i18n['user_id']"
                type="text"
                :old="dOld"
                required
                autofocus
              ></input-group>

              <input-group
                name="password"
                :name-string="i18n['password']"
                type="password"
                :old="dOld"
                required
              ></input-group>

              <div class="form-group row">
                <div class="col-md-6 offset-md-4">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      name="remember"
                      id="remember"
                    />

                    <label class="form-check-label" for="remember">
                      {{ i18n["remember_me"] }}
                    </label>
                  </div>
                </div>
              </div>

              <div class="form-group row mb-0 text-center">
                <div class="col-12">
                  <button type="submit" class="btn btn-primary">
                    <i class="fas fa-sign-in-alt"></i>
                    {{ i18n["login"] }}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    loginUrl: String,
    registerUrl: String,
    passwordRequestUrl: String,
    errors: String,
    old: String,
    csrf: String,
  },
  data() {
    return {
      user_id: null,
      password: null,
      dErrors: JSON.parse(this.errors),
      dOld: JSON.parse(this.old),
      companyCode: "",
    };
  },

  mounted() {
    this.retrieveCompanyId();
  },

  methods: {
    handleSubmit() {
      runSpinner(i18n["logging_in"]);
      this.storeCompanyId();
    },

    updateEnteredCompanyId(data) {
      this.companyCode = data;
    },

    goToRegister() {
      window.location.href = this.registerUrl;
    },

    storeCompanyId() {
      localStorage.setItem("company_id", this.companyCode);
    },

    retrieveCompanyId() {
      const companyId = localStorage.getItem("company_id");
      if (companyId != null) {
        this.companyCode = companyId;
      }
    },
  },
};
</script>
